import { MESSAGES } from '../constants';

export const errorService = error => {
  const response = error.response;

  if (response && response.status === 401) {
    return MESSAGES.wrongEmailOrPassword;
  }

  if (response && response.status === 404) {
    return MESSAGES.urlNotFound;
  }

  if (response && response.status === 422) {
    if (response.data.message) {
      if (response.data.message === 'The email has already been taken.') {
        return 'An account with this email already exists.';
      }

      return MESSAGES.somethingWentWrong;
    }

    return response;
  }

  if (response && response.status === 429) {
    return MESSAGES.tooManyRequests;
  }

  if (response && response.status > 499 && response && response.status <= 599) {
    return MESSAGES.internalServerError;
  }
};
